import {useAtom} from "jotai";
import {Input, MenuItem, Select} from "@mui/material";
import {fieldHistoryDaysAtom} from "../../store/fieldHistoryDaysStore";
import {FieldHistoryDaysType} from "../../types/fieldHistoryDays";
import {useTranslation} from "react-i18next";
import {TFunction} from "i18next";

export const HistoryDaysSelector: React.FC = () => {
    const {t} = useTranslation();
    const [fieldHistoryDays, setFieldHistoryDays] = useAtom(fieldHistoryDaysAtom);

    return (
        <Select
            margin="none"
            size="small"
            id="name"
            fullWidth
            variant="standard"
            onChange={(event) => setFieldHistoryDays(event.target.value as FieldHistoryDaysType)}
            value={fieldHistoryDays}
            input={
                <Input
                    sx={{
                        fontSize: 14,
                        textTransform: "uppercase",
                        "& .MuiInput-input": {
                            paddingY: "0.2rem",
                        },
                    }}
                />
            }
        >
            {historyDaysOptions(t).map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    );
};

const historyDaysOptions = (t: TFunction<string, undefined>) =>
    [15, 30, 60, "ALL"].map((id) => ({
        id,
        label:
            id === "ALL"
                ? t("insights.field_insights_view.list.all")
                : `${id} ${t("insights.field_insights_view.list.days")}`,
    }));
